import React from 'react';
import EpisodeDocumentView from './EpisodeDocumentView';

/* EpisodeReadingPane — just the episode brief document.
   The audio player + Spin-off CTA moved up into EpisodeHero (right of
   the cover art). This component used to own its own vertical scroll;
   it doesn't anymore — the parent ws-editor-body owns the single page
   scroll so the user only sees one scrollbar on the doc surface. */

export default function EpisodeReadingPane({ episode, onBack }) {
  return (
    <div className="ws-reading-pane">
      <EpisodeDocumentView episode={episode} onBack={onBack} />
    </div>
  );
}
